<template>
  <div class="flex-c hdr page-header">
    <img class="logo-icon" src="@/assets/adapt.png" />
    <div class="info-header-menu">
      <div class="flex-col" v-if="!lbCreditsPlan">
        <span v-if="views && views >= 10000000">Unlimited</span>
        <span v-if="views && views < 10000000">{{ views | formatNumber }}</span>
        <span v-if="!views">0</span>
        <span class="fn-11">{{ views == 1 ? 'Credit' : 'Credits' }}</span>
      </div>
      <div class="flex-col" v-if="lbCreditsPlan">
        <span v-if="credits && credits >= 10000000">Unlimited</span>
        <span v-if="credits && credits < 10000000">{{
          credits | formatNumber
        }}</span>
        <span v-if="!credits">0</span>
        <span class="fn-11">{{ credits == 1 ? 'Credit' : 'Credits' }}</span>
      </div>
      <!-- <div class="flex-col text-white pl-5px-im">
        <span v-if="downloads && downloads >= 10000000"> Unlimited </span>
        <span v-if="downloads && downloads < 10000000">
          {{ downloads | formatNumber }}
        </span>
        <span v-if="!downloads">0</span>
        <span class="fn-11">Downloads</span>
      </div>-->
      <div class="upgrade-icon" title="Upgrade" v-if="!isPaidUser">
        <Upgrade-Icon @click="redirectPricing" />
      </div>
      <div class="reload-page">
        <Sync-Icon @click="reloadPage" />
      </div>
      <div
        v-if="isDockSettingsAvailable"
        class="dot-menu"
        @mouseover="showDockMenu = true"
        @mouseleave="showDockMenu = false"
      >
        <i class="material-icons">more_vert</i>

        <div v-if="showDockMenu == true" class="hidden-arrow"></div>
        <div class="dock-options" v-if="showDockMenu == true">
          <div class="dock-option-wrap">
            <div class="txt">Dock align</div>
            <div
              :class="[
                { 'is-pin-option-enabled': showPinOption == true },
                'dock-options-list',
              ]"
            >
              <div
                :class="[
                  { 'is-select': getDockModeType == 'left-dock' },
                  'dock-option-item',
                  'left-dock-option',
                ]"
                @click="switchDockMode('left-dock')"
              >
                <DockLeft-Icon />
                <div class="tool-tip">
                  <div class="sharp-point" />
                  <div class="tool-tip-wrap">
                    Dock Prospector to the left
                    <span>
                      (Prospector automatically loads contact data - no refresh
                      required)</span
                    >
                  </div>
                </div>
              </div>
              <div
                :class="[
                  { 'is-select': getDockModeType == 'right-dock' },
                  'dock-option-item',
                  'right-dock-option',
                ]"
                @click="switchDockMode('right-dock')"
              >
                <DockRight-Icon />
                <div class="tool-tip">
                  <div class="sharp-point" />
                  <div class="tool-tip-wrap">
                    Prospector floats over to the right
                  </div>
                </div>
              </div>
              <div
                v-if="showPinOption == true"
                :class="[
                  { 'is-select': getDockModeType == 'pin-dock' },
                  'dock-option-item',
                  'pin-dock-option',
                ]"
                @click="switchDockMode('pin-dock')"
              >
                <PushPin-Icon />
                <div class="tool-tip">
                  <div class="sharp-point" />
                  <div class="tool-tip-wrap">
                    Pin prospector here (maintains window sizing)
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { put } from '@/assets/util/rest.js'
import syncIcon from '@/assets/icons/svg/sync.svg'
import UpgradeIcon from '@/assets/icons/svg/upgradeRocket.svg'
import PushPinIcon from '@/assets/icons/svg/push-pin.svg'
import DockLeftIcon from '@/assets/icons/svg/dock-left.svg'
import DockRightIcon from '@/assets/icons/svg/dock-right.svg'
import sharedFunctions from '@/assets/util/functions.js'
import { MxEvent, HttpUrl } from '@/assets/util/constants/analytics.js'
import { BASE_URL_NEW } from '@/assets/util/constants/constants.js'

export default {
  name: 'Header',
  components: {
    'Sync-Icon': syncIcon,
    'Upgrade-Icon': UpgradeIcon,
    'PushPin-Icon': PushPinIcon,
    'DockLeft-Icon': DockLeftIcon,
    'DockRight-Icon': DockRightIcon,
  },
  data() {
    return {
      showDockMenu: false,
      showPinOption: false,
      pinOptionChecked: false,
    }
  },
  methods: {
    switchDockMode(dockModeType) {
      this.$store.state.dockModeType = dockModeType
      sharedFunctions.passMsgToContentScript({
        type: 'toggle-dock',
        mode: dockModeType,
      })
      sharedFunctions.track(MxEvent.toggleDockView, null, this.$store.state)
      let successMsg = ''
      if (dockModeType == 'right-dock') {
        successMsg = 'Successfully pinned to the right'
      } else if (dockModeType == 'left-dock') {
        successMsg = 'Successfully docked to the left'
      } else if (dockModeType == 'pin-dock') {
        successMsg = 'Pinned here successfully'
      }
      sharedFunctions.showNotificationMsg(successMsg, 2000, '#4CAF50', '#fff')
    },
    reloadPage() {
      location.reload()
    },
    redirectPricing() {
      sharedFunctions.track(
        MxEvent.upgradeHeaderRocket,
        null,
        this.$store.state
      )
      window.open(`${BASE_URL_NEW}/pricing`)
    },
    checkLiButtonEnable() {
      return (
        !this.$store.state.header.linkedinFollow &&
        !this.$store.state.header.isPaidUser
      )
    },
    dockModeChangeListener() {
      const that = this
      window.addEventListener('message', function (ev) {
        if (
          ev &&
          ev.data &&
          (ev.data.type == 'dockModeType' || ev.data.type == 'isDockLeft')
        ) {
          if (ev.data.data == null) {
            that.$store.state.isDockSettingsAvailable = false
          } else {
            that.$store.state.isDockSettingsAvailable = true
            that.$store.state.dockModeType = ev.data.data
              ? ev.data.data == true
                ? 'left-dock'
                : ev.data.data
              : 'right-dock'
          }
        } else if (ev && ev.data && ev.data.type == 'li-follower-status') {
          if (!ev.data.data) {
            that.$store.state.header.canShowLinkedinFollow = true
            if (!that.checkLiButtonEnable()) {
              const dataMap = {
                data: '',
                type: 'ALREADY_LI_FOLLOWED',
                value: true,
              }
              window.postMessage(dataMap, '*')
            }
          } else if (ev.data.data) {
            that.$store.state.header.linkedinFollow = true
            put(HttpUrl.linkedinFollow)
          }
        } else if (ev && ev.data && ev.data.type == 'PIN_OPTION_ENABLED') {
          if (ev.data.data) {
            that.showPinOption = true
          } else {
            that.showPinOption = false
          }
        }
      })

      if (!that.pinOptionChecked) {
        that.pinOptionChecked = true
        setTimeout(function () {
          sharedFunctions.passMsgToContentScript({
            type: 'CHECK_PIN_OPTION_ENABLED',
          })
        }, 300)
      }
    },
  },
  created() {
    this.dockModeChangeListener()
  },
  computed: {
    views() {
      return this.$store.state.header.views
    },
    downloads() {
      return this.$store.state.header.downloads
    },
    lbCreditsPlan() {
      return this.$store.state.header.lbCreditsPlan
    },
    credits() {
      return this.$store.state.header.credits
    },
    isPaidUser() {
      return this.$store.state.header.isPaidUser
    },
    getDockModeType() {
      return this.$store.state.dockModeType
    },
    isDockSettingsAvailable() {
      return this.$store.state.isDockSettingsAvailable
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.page-header {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 111;
  background: $primary-color;
  padding: 5px 10px;
  width: 100%;
  display: grid;
  grid-template-columns: 80px calc(100% - 90px);
  justify-content: space-between;
  align-items: center;
  .logo-icon {
    position: relative;
    width: 70px;
    @include flex-center;
  }
  .info-header-menu {
    @include flex-center-right();
    color: $white;
    .flex-col {
      display: flex;
      flex-direction: column;
      align-items: baseline;
      justify-content: center;
      padding: 5px 0;
    }
    .reload-page {
      margin-left: 10px;
      svg {
        @include wt-ht(18px, 18px);
        width: 18px;
        fill: $white;
        cursor: pointer;
      }
    }
    .upgrade-icon {
      margin-left: 10px;
      @include wt-ht(24px, 24px);
      svg {
        @include wt-ht(24px, 24px);
        fill: $white;
        cursor: pointer;
      }
      &:hover {
        animation: MoveUpDown linear 1000ms 3;
      }
    }
  }
  .dot-menu {
    position: relative;
    cursor: pointer;
    margin-left: 10px;
    display: inline-block;
    i {
      color: $white;
    }
    .hidden-arrow {
      padding: 10px 30px;
      position: absolute;
      top: 17px;
      left: -30px;
    }
    .dock-options {
      position: absolute;
      width: 240px;
      right: -3px;
      top: 30px;
      .dock-option-wrap {
        border-radius: 5px;
        position: relative;
        background: $white;
        padding: 10px;
        display: flex;
        align-items: center;
        box-shadow: 0px 2px 3px 1px #cecece;
        justify-content: space-between;
        position: relative;
      }
      .txt {
        color: #787878;
        font-size: 14px;
        padding-right: 10px;
        min-width: fit-content;
      }
      .dock-options-list {
        display: flex;

        .dock-option-item {
          width: 34px;
          height: 34px;
          border: 1px solid #eee;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-left: 5px;

          .tool-tip {
            position: absolute;
            width: 240px;
            z-index: 22;
            font-size: 13px;
            top: 54px;
            right: 0px;
            display: none;
            .tool-tip-wrap {
              box-shadow: 0px 2px 3px 1px #cecece;
              padding: 15px;
              background-color: #f6f6f6;
              position: relative;
              z-index: 1;
              text-align: center;
              line-height: 18px;
              border-radius: 7px;
              border: 1px solid #cecece;
              color: #000;

              span {
                font-size: 11px;
                line-height: 14px;
              }
            }
            .sharp-point {
              width: 20px;
              height: 20px;
              border: none;
              position: absolute;
              transform: rotate(45deg);
              z-index: 2;
              right: 16px;
              top: -10px;
              border-top: 1px solid #cecece;
              border-left: 1px solid #cecece;
              background-color: #f6f6f6;
            }
          }
        }

        .dock-option-item.left-dock-option {
          .tool-tip {
            .sharp-point {
              right: 55px;
            }
          }
        }

        .dock-option-item:hover {
          box-shadow: 0 1px 3px 0 rgba(60, 64, 67, 0.302),
            0 1px 4px 2px rgba(60, 64, 67, 0.149);
          background-color: #f0f0f1;
          .tool-tip {
            display: block;
          }
        }
        .dock-option-item.is-select {
          background-color: #2080ee;
          border-color: #2080ee;

          svg {
            path {
              fill: #fff;
            }
          }
        }
      }
      .dock-options-list.is-pin-option-enabled {
        .dock-option-item.left-dock-option {
          .tool-tip {
            .sharp-point {
              right: 95px;
            }
          }
        }
        .dock-option-item.right-dock-option {
          .tool-tip {
            .sharp-point {
              right: 55px;
            }
          }
        }
      }
      img,
      svg {
        height: 13px;
        width: 17px;
      }
    }
  }
}
</style>
